import { render, staticRenderFns } from "./JourneyStep.vue?vue&type=template&id=de067fbe"
import script from "./JourneyStep.vue?vue&type=script&lang=js"
export * from "./JourneyStep.vue?vue&type=script&lang=js"
import style0 from "./JourneyStep.vue?vue&type=style&index=0&id=de067fbe&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports